import { useState, useCallback } from 'react';
import { Store, DistanceUnit } from '../types';
import api from '../services/bff';

export default function useStores() {
  const [stores, setStores]: [Store[], Function] = useState([]);

  const fetchStores = useCallback(
    async (latitude: number, longitude: number, uom = DistanceUnit.Metric) => {
      const fetch = async () => {
        const resp = await api.getStores(latitude, longitude, uom);
        setStores(resp.data);
      };
      await fetch();
    },
    [],
  );

  return {
    stores,
    fetchStores,
  };
}
